import { render, staticRenderFns } from "./honordetails.vue?vue&type=template&id=0360971a&scoped=true&"
import script from "./honordetails.vue?vue&type=script&lang=js&"
export * from "./honordetails.vue?vue&type=script&lang=js&"
import style0 from "./honordetails.vue?vue&type=style&index=0&id=0360971a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0360971a",
  null
  
)

export default component.exports